var _path, _path2, _circle, _circle2, _circle3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSaas(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.50977,45.44971a3.633,3.633,0,0,0-5.02051.00146l-1.41748,1.42432-.6001-.56885A3.54278,3.54278,0,0,0,54.542,46.354l-6.91723,6.95923A3.714,3.714,0,0,0,47,53.25H32.48535a6.71157,6.71157,0,0,0-4.77344,1.977L13.46973,69.46973l1.06054,1.06054L28.77246,56.28809A5.21958,5.21958,0,0,1,32.48535,54.75H47A2.25278,2.25278,0,0,1,49.25,57a2.30346,2.30346,0,0,1-.70654,1.45984l-.0503.05041.001.001a2.20622,2.20622,0,0,1-1.42871.73047L35.999,59.25l.002,1.5,11.06543-.0083a3.70934,3.70934,0,0,0,2.55932-1.24426L62.55078,46.51025a2.07843,2.07843,0,0,1,2.89844,2.9795L51.22754,63.71191A5.21958,5.21958,0,0,1,47.51465,65.25H32.82812a2.73171,2.73171,0,0,0-1.94433.80566l-3.41406,3.41407,1.06054,1.06054,3.41407-3.41406a1.257,1.257,0,0,1,.88378-.36621H47.51465A6.71157,6.71157,0,0,0,52.28809,64.773L66.50977,50.55029a3.606,3.606,0,0,0,0-5.10058ZM50.68042,56.31238a3.74978,3.74978,0,0,0-1.54663-2.389L55.59863,47.419a2.04471,2.04471,0,0,1,2.8418-.023l.57324.54284Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56,40.75a.7502.7502,0,0,0,.75-.75V10A.7502.7502,0,0,0,56,9.25H24a.7502.7502,0,0,0-.75.75V40a.7502.7502,0,0,0,.75.75Zm-31.25-30h30.5v6.5H24.75Zm0,8h30.5v20.5H24.75Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 14,
    r: 1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 14,
    r: 1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 14,
    r: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSaas);
export default __webpack_public_path__ + "static/media/icon_saas.d2ee349d866c5e66ad1d1ed2b45693da.svg";
export { ForwardRef as ReactComponent };